import ICompany, { ICompanyWaiter } from "@/interfaces/ICompany";
import IQRCodeResult from "@/interfaces/IQRCodeResult";
import { CustomRequest } from "@/services/api";
import { GetDeviceId } from "@/utils/ReactNativeUtils";

export function GetCompany(id_company: number) {
  return CustomRequest<ICompany>(`/company/${id_company}`);
}

export function GetQRCodeData(qrCode: string) {
  return CustomRequest<IQRCodeResult>(`/waiter/qr_code/${qrCode}`, {
    cache: "no-cache",
  });
}

export function GetCompanyWaiter(id_company: number) {
  return CustomRequest<ICompanyWaiter>(`/company/${id_company}/waiter`);
}

export async function PushQrCodeDeviceID(qrCode: string) {
  const deviceId = await GetDeviceId();

  return CustomRequest(`/waiter/qr_code/${qrCode}/device`, {
    method: "POST",
    headers: { "x-device-id": deviceId || "" },
  });
}
